import React from "react";
import WelcomeSection from "../components/WelcomeSection";
import HeroButtons from "../components/HeroButtons";

function Home() {
  return (
    <>
      <WelcomeSection />
      <HeroButtons />

      {/* Simple footer for mobile */}
      <div className="px-6 py-8 text-center">
        <p className="text-gray-400 text-sm opacity-70">
          Secure • Professional • Reliable
        </p>
      </div>
    </>
  );
}

export default Home;
